import React from 'react';
import InputComp from '../InputComp';
import SelectComp from '../SelectComp';
import {BASE_URL} from "../../helpers/variables";
import Chip from '@material-ui/core/Chip';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Snackbar from '@material-ui/core/Snackbar';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import CardHeader from '@material-ui/core/CardHeader';
import IconButton from "@material-ui/core/IconButton";
import ShoppingBasket from "@material-ui/icons/ShoppingBasket";
import Button from "@material-ui/core/Button";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import { withStyles } from '@material-ui/core/styles';
import CheckBoxComp from "../CheckBoxComp";
import { PDF_TYPES } from '../../helpers/constants/productAttachmentTypes';
import RelatedProductsAutocomplete from './relatedProductsAutocomplete';
import UploadedFile from './uploadedFile';
import Select from 'react-select';
import getGenericAttachmentUrl from '../../helpers/unileverSales/getGenericAttachmentUrl';
import Colors from '../../helpers/constants/colors';

const styles = {
    button: {
        margin: 12,
    },
    image: {
    },
    exampleImageInput: {
        cursor: 'pointer',
        position: 'absolute',
        top: 0,
        bottom: 0,
        right: 0,
        left: 0,
        width: '100%',
        opacity: 0,
    },
};

const ProductsFormComponent = (props) => {
    const { classes, recipes, uploading, errorMessage } = props;
    return (
        <div>
            <Dialog
                open={props.productsStore.isDeleteModalOpen}
                onClose={() => props.changeStoreSettings('isDeleteModalOpen', !props.productsStore.isDeleteModalOpen)}
            >
                <DialogTitle>{"Delete Product"}</DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        Are you sure you want to delete the selected product?
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button  onClick={props.handleDelete} color="primary" autoFocus>
                        Delete
                    </Button>
                    <Button onClick={() =>
                        props.changeStoreSettings('isDeleteModalOpen', !props.productsStore.isDeleteModalOpen)}
                            color="secondary">
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>
            <Dialog
                fullWidth={true}
                title="image"
                open={props.productsStore.isImageModalOpen}
                onClose={() => props.changeStoreSettings('isImageModalOpen', false)}
            >
                <DialogTitle>{"Image"}</DialogTitle>
                <DialogContent>
                    <DialogContentText >
                        <img src={props.product.attachment.base64?props.product.attachment.base64: (BASE_URL +
                            'api/attachments/images/download/' + props.product.imageName)}
                             className={'img-fluid'}
                        />
                    </DialogContentText>
                </DialogContent>
                <DialogActions>
                    <Button  onClick={() => props.changeStoreSettings('isImageModalOpen', false)}
                             color="primary" autoFocus>
                        Close
                    </Button>
                </DialogActions>
            </Dialog>
            <Card>
                <CardHeader
                    avatar={
                        <IconButton>
                            <ShoppingBasket />
                        </IconButton>
                    }
                    title={props.isNew?'Create Product':'Edit Product'}
                />
                <CardContent>
                    <div className="col col-lg-4 offset-lg-3 ">
                        <form id="form-product" onSubmit={props.handleSubmit}>
                            <InputComp Required={true} Placeholder="Product name" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.product_name} Name="product_name" Label="Name"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <SelectComp Required={true} Values={props.categoriesResultsToDisplay.map(item => {return {key: item.id, value: item.level ? "-".repeat(item.level) + item.label : item.label}})} Label="Category *"
                                        fullWidth={true} margin={'normal'}
                                        TargetObj={props.selectedMenuItem?parseInt(props.selectedMenuItem):''} Name="cid" MenuName="Select Category"
                                        PropHandleInputChange={props.handleInputChange}/>
                            <InputComp Required={true} Placeholder="Product code" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.productCode} Name="productCode" Label="Product Code"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <SelectComp Required={false} Values={props.brands.map(item => {return {key: item.id, value: item.name}})} Label="Μαρκα"
                                        fullWidth={true} margin={'normal'}
                                        TargetObj={props.product.productBrandId?parseInt(props.product.productBrandId):''} Name="productBrandId" MenuName="Μαρκα"
                                        PropHandleInputChange={props.handleInputChange}/>
                            <SelectComp Required={false}
                                        Values={props.categoriesResultsToDisplay.map(item => {return {key: item.id, value: item.level ? "-".repeat(item.level) + item.label : item.label}})}
                                        Label="Related Category"
                                        fullWidth={true} margin={'normal'}
                                        TargetObj={props.product.relatedCategoryId?parseInt(props.product.relatedCategoryId):''} Name="relatedCategoryId" MenuName="Related Category"
                                        PropHandleInputChange={props.handleInputChange}/>
                            <div style={{
                                marginTop: 10,
                                paddingVertical: 20
                            }}>
                                <Select
                                  value={props.product.operatorGroupsIds}
                                  onChange={props.isNew ? props.setOperatorGroups : props.editOperatorGroups}
                                  options={props.operatorGroups.map(label => {
                                      return {
                                          value: label.id,
                                          label: label.name,
                                      }
                                  })}
                                  isMulti
                                  isSearchable
                                  placeholder={"Add operator groups"}
                                />
                            </div>
                            <div style={{
                                marginTop: 10,
                                paddingVertical: 20
                            }}>
                                <Select
                                  value={props.product.productLabelIds}
                                  onChange={props.isNew ? props.setProductLabel : props.editProductLabel}
                                  options={props.labels.map(label => {
                                      return {
                                          value: label.id,
                                          label: label.name,
                                      }
                                  })}
                                  isMulti
                                  isSearchable
                                  placeholder={"Add related product labels (Vegan etc) ..."}
                                />
                            </div>
                            <RelatedProductsAutocomplete
                              products={props.isNew ?
                                props.productsStore.all
                                : props.productsStore.all.filter(prod => prod.id !== props.product.productId)}
                              relatedProductsSelected={props.isNew ? props.relatedProductsSelected : props.relatedProductsEdit}
                              setRelatedProducts={props.isNew ? props.setRelatedProducts : props.setRelatedProductsEdit}
                            />
                            <InputComp Required={false} Placeholder="EAN Code CU" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.eanCodeCu} Name="eanCodeCu" Label="EAN Code CU"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={false} Placeholder="EAN Code DU" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.eanCodeDu} Name="eanCodeDu" Label="EAN Code DU"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={false} Placeholder="Συσκευασία" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.packing} Name="packing" Label="Συσκευασία"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={false} Placeholder="Διάρκεια ζωής" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.durationOfLife} Name="durationOfLife" Label="Διάρκεια ζωής (σε μήνες)"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={false} Placeholder="Διάρκεια ζωής μετά το άνοιγμα" Type="text"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.durationOfLifeAfterOpening} Name="durationOfLifeAfterOpening" Label="Διάρκεια ζωής μετά το άνοιγμα (σε βδομάδες)"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={true} Min={0.01} Placeholder="Product value" Type="number"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.value} Step="0.01" Name="value" Label="Value"
                                       PropHandleInputChange={props.handleTextInputChange} hidden/>
                            <InputComp Required={true} Placeholder="Product points" Type="number"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.points} Step="1" Name="points" Label="Points"
                                       PropHandleInputChange={props.handleTextInputChange} hidden />
                            <InputComp Placeholder="Product description" Type="text" Value={props.product.description}
                                       fullWidth={true} margin={'normal'}
                                       Name="description" Label="Description"
                                       PropHandleInputChange={props.handleTextInputChange}/>
                            <InputComp Required={false}
                                       fullWidth={true} margin={'normal'}
                                       Placeholder="format:dd-mm-yyyy hh:mm" Type="date" Name="startDate"
                                       Label="Start Date" Value={props.product.startDate}
                                       PropHandleInputChange={props.handleInputChange} hidden/>
                            <InputComp Required={false}
                                       fullWidth={true} margin={'normal'}
                                       Placeholder="format:dd-mm-yyyy hh:mm" Type="date" Name="endDate"
                                       Label="End Date" Value={props.product.endDate}
                                       PropHandleInputChange={props.handleInputChange} hidden/>
                            <InputComp Placeholder="Experience type" Type="text" Value={props.product.xpType}
                                       fullWidth={true} margin={'normal'}
                                       Name="xpType" Label="Experience type"
                                       PropHandleInputChange={props.handleTextInputChange} hidden />
                            <InputComp Required={false} Placeholder="Erp Id" Type="number"
                                       fullWidth={true} margin={'normal'}
                                       Value={props.product.erpId} Step="1" Name="erpId" Label="Erp Id"
                                       PropHandleInputChange={props.handleTextInputChange} hidden />
                            <CheckBoxComp
                                Checked={props.product.isTop10}
                                Type="checkbox"
                                Name="isTop10"
                                Label="Is a top 10 product?" PropHandleInputChange={(name, checked) => {
                                    props.handleInputChange(name, checked)
                                }}
                            />
                            <CheckBoxComp
                                Checked={props.product.pointsApplyOnce}
                                Type="checkbox"
                                Name="pointsApplyOnce"
                                Label="Apply points only once" PropHandleInputChange={(name, checked) => {
                                    props.handleInputChange(name, checked)
                                }}
                                hidden
                            />
                            <CheckBoxComp
                                Checked={props.product.xp}
                                Name="xp"
                                Type="checkbox"
                                Label="Experience" PropHandleInputChange={(name, checked) => {
                                    props.handleInputChange(name, checked)
                                }}
                                hidden
                            />
                            {
                                !props.isNew && recipes.length ?
                                  <div
                                    style={{
                                        backgroundColor: Colors.UNILEVER_RED,
                                        padding: 20,
                                    }}
                                  >
                                      {recipes.length ? <div
                                          style={{
                                              color: Colors.WHITE,
                                              paddingLeft: 10,
                                          }}>
                                          <span
                                            style={{
                                                marginBottom: 10,
                                                paddingLeft: 2,
                                                fontWeight: 'bold'
                                            }}
                                          >
                                            Uploaded recipes
                                              </span>
                                            {recipes.map((vid, index) =>
                                              <div
                                                style={{
                                                    marginTop: 5,
                                                    marginBottom: 5,
                                                    paddingBottom: 5,
                                                }}
                                              >
                                                  <Chip
                                                    label={vid.name}
                                                    onDelete={() => props.removeRecipe(vid)}
                                                    onClick={()=>{
                                                        if (vid.hash)
                                                          window.open(BASE_URL + 'api/attachments/images/download/' + vid.hash, "_blank");
                                                    }}
                                                  />
                                              </div>)}
                                        </div>
                                              : null}
                                      {recipes.length < 3 ? <Button variant="contained" color="default" className={classes.button}>
                                          Προσθηκη συνταγης
                                          <CloudUploadIcon className={classes.rightIcon} />
                                          <input
                                            type="file"
                                            accept="video/mp4,video/x-m4v,video/*"
                                            onChange={(evt) => {
                                                props.onAddRecipe(evt,PDF_TYPES.VIDEOS);
                                            }}
                                            style={styles.exampleImageInput} />
                                      </Button> : null}
                                  </div> : null
                            }
                            {!props.isNew && !recipes.length ? <div><Button variant="contained" color="default" className={classes.button}>
                                Προσθηκη συνταγης
                                <CloudUploadIcon className={classes.rightIcon} />
                                <input
                                  type="file"
                                  accept="video/mp4,video/x-m4v,video/*"
                                  onChange={(evt) => {
                                      props.onAddRecipe(evt,PDF_TYPES.VIDEOS);
                                  }}
                                  style={styles.exampleImageInput} />
                            </Button></div> : null}
                            <Button variant="contained" color="default" className={classes.button}>
                                Upload image
                                <CloudUploadIcon className={classes.rightIcon} />
                                <input type="file" accept="image/x-png,image/gif,image/jpeg" onChange={(evt) => props.handleImageInput(evt)} style={styles.exampleImageInput} />
                            </Button>
                            {
                                props.product.attachment.name || props.product.imageName?
                                  <Chip
                                    label={props.product.attachment.name || props.product.imageName}
                                    onDelete={props.removeAttachment}
                                    onClick={()=>props.changeStoreSettings('isImageModalOpen', true)}
                                  />
                                  :
                                  null
                            }
                        </form>
                    </div>
                    <div className="col col-lg-4 offset-lg-3 ">
                        <Button variant="contained" color="default" className={classes.button}>
                            Στοιχεια (PDF)
                            <CloudUploadIcon className={classes.rightIcon} />
                            <input type="file" accept="application/pdf" onChange={(evt) => props.handlePdfInput(evt, PDF_TYPES.PRODUCT_ELEMENTS)} style={styles.exampleImageInput} />
                        </Button>
                        {
                            props.product[PDF_TYPES.PRODUCT_ELEMENTS] && props.product[PDF_TYPES.PRODUCT_ELEMENTS].name ?
                              <Chip
                                label={props.product[PDF_TYPES.PRODUCT_ELEMENTS].name}
                                onDelete={() => props.removePdf(PDF_TYPES.PRODUCT_ELEMENTS)}
                                // onClick={()=>props.changeStoreSettings('isImageModalOpen', true)}
                              />
                              :
                              null
                        }
                        {
                            !props.isNew
                            && props.product[PDF_TYPES.PRODUCT_ELEMENTS]
                            && props.product[PDF_TYPES.PRODUCT_ELEMENTS].hash
                              ?
                              <Chip
                                label={props.product[PDF_TYPES.PRODUCT_ELEMENTS].hash}
                                onDelete={() => props.removePdf(PDF_TYPES.PRODUCT_ELEMENTS)}
                                onClick={()=> window.open(getGenericAttachmentUrl(props.product[PDF_TYPES.PRODUCT_ELEMENTS].hash), "_blank")}
                              />
                              :
                              null
                        }
                    </div>
                    <div className="col col-lg-4 offset-lg-3 ">
                    <Button variant="contained" color="default" className={classes.button}>
                        Προδιαγραφες (PDF)
                        <CloudUploadIcon className={classes.rightIcon} />
                        <input type="file" accept="application/pdf" onChange={(evt) => props.handlePdfInput(evt,PDF_TYPES.PRODUCT_SPECIFICATIONS)} style={styles.exampleImageInput} />
                    </Button>
                    {
                        props.isNew && props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS] && props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].name ?
                          <Chip
                            label={props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].name}
                            onDelete={() => props.removePdf(PDF_TYPES.PRODUCT_SPECIFICATIONS)}
                            onClick={()=>props.changeStoreSettings('isImageModalOpen', true)}
                          />
                          :
                          null
                    }
                        {
                            !props.isNew
                            && props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS]
                            && (props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].hash || props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].name)
                              ?
                              <Chip
                                label={props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].hash || props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].name}
                                onDelete={() => props.removePdf(PDF_TYPES.PRODUCT_SPECIFICATIONS)}
                                onClick={()=> window.open(getGenericAttachmentUrl(props.product[PDF_TYPES.PRODUCT_SPECIFICATIONS].hash), "_blank")}
                              />
                              :
                              null
                        }
                    </div>
                    {props.isNew ? <div className="col col-lg-4 offset-lg-3 ">
                        {recipes.length < 3 ? <Button variant="contained" color="default" className={classes.button}>
                            Προσθηκη συνταγης
                            <CloudUploadIcon className={classes.rightIcon} />
                            <input
                              type="file"
                              accept="video/mp4,video/x-m4v,video/*"
                              onChange={(evt) => {
                                  props.onAddRecipe(evt,PDF_TYPES.VIDEOS);
                              }}
                              style={styles.exampleImageInput} />
                        </Button> : null}
                        {errorMessage ? <div style={{color: 'red'}}>{errorMessage}</div> : null}
                        {uploading ? <div>Uploading</div> : null}
                        {recipes.length ?
                          recipes.map(recipe =>
                            <UploadedFile
                              key={recipe.name}
                              name={recipe.name}
                              size={recipe.size}
                              remove={() => props.removeRecipe(recipe)}
                            />)
                          : null
                        }
                    </div> : null}
                    <div className="col col-lg-4 offset-lg-3 ">
                        <Button variant="contained" color="default" className={classes.button}>
                            Internal 1 (PDF)
                            <CloudUploadIcon className={classes.rightIcon} />
                            <input
                              type="file"
                              accept="application/pdf"
                              onChange={(evt) =>
                                props.handlePdfInput(evt, PDF_TYPES.INTERNAL_ONE)}
                              style={styles.exampleImageInput}
                            />
                        </Button>
                        {
                            props.product[PDF_TYPES.INTERNAL_ONE] && props.product[PDF_TYPES.INTERNAL_ONE].name ?
                              <Chip
                                label={props.product[PDF_TYPES.INTERNAL_ONE].name}
                                onDelete={() => props.removePdf(PDF_TYPES.INTERNAL_ONE)}
                              />
                              :
                              null
                        }
                        {
                            !props.isNew
                            && props.product[PDF_TYPES.INTERNAL_ONE]
                            && props.product[PDF_TYPES.INTERNAL_ONE].hash
                              ?
                              <Chip
                                label={props.product[PDF_TYPES.INTERNAL_ONE].hash}
                                onDelete={() => props.removePdf(PDF_TYPES.INTERNAL_ONE)}
                                onClick={()=> window.open(getGenericAttachmentUrl(props.product[PDF_TYPES.INTERNAL_ONE].hash), "_blank")}
                              />
                              :
                              null
                        }
                    </div>
                    <div className="col col-lg-4 offset-lg-3 ">
                        <Button variant="contained" color="default" className={classes.button}>
                            Internal 2 (PDF)
                            <CloudUploadIcon className={classes.rightIcon} />
                            <input
                              type="file"
                              accept="application/pdf"
                              onChange={(evt) =>
                                props.handlePdfInput(evt, PDF_TYPES.INTERNAL_TWO)}
                              style={styles.exampleImageInput}
                            />
                        </Button>
                        {
                            props.product[PDF_TYPES.INTERNAL_TWO] && props.product[PDF_TYPES.INTERNAL_TWO].name ?
                              <Chip
                                label={props.product[PDF_TYPES.INTERNAL_TWO].name}
                                onDelete={() => props.removePdf(PDF_TYPES.INTERNAL_TWO)}
                              />
                              :
                              null
                        }
                        {
                            !props.isNew
                            && props.product[PDF_TYPES.INTERNAL_TWO]
                            && props.product[PDF_TYPES.INTERNAL_TWO].hash
                              ?
                              <Chip
                                label={props.product[PDF_TYPES.INTERNAL_TWO].hash}
                                onDelete={() => props.removePdf(PDF_TYPES.INTERNAL_TWO)}
                                onClick={()=> window.open(getGenericAttachmentUrl(props.product[PDF_TYPES.INTERNAL_TWO].hash), "_blank")}
                              />
                              :
                              null
                        }
                    </div>
                    <div className="col col-lg-4 offset-lg-3 ">
                        <Button variant="contained" color="default" className={classes.button}>
                            External 1 (PDF)
                            <CloudUploadIcon className={classes.rightIcon} />
                            <input
                              type="file"
                              accept="application/pdf"
                              onChange={(evt) =>
                                props.handlePdfInput(evt, PDF_TYPES.EXTERNAL_ONE)}
                              style={styles.exampleImageInput}
                            />
                        </Button>
                        {
                            props.product[PDF_TYPES.EXTERNAL_ONE] && props.product[PDF_TYPES.EXTERNAL_ONE].name ?
                              <Chip
                                label={props.product[PDF_TYPES.EXTERNAL_ONE].name}
                                onDelete={() => props.removePdf(PDF_TYPES.EXTERNAL_ONE)}
                              />
                              :
                              null
                        }
                        {
                            !props.isNew
                            && props.product[PDF_TYPES.EXTERNAL_ONE]
                            && props.product[PDF_TYPES.EXTERNAL_ONE].hash
                              ?
                              <Chip
                                label={props.product[PDF_TYPES.EXTERNAL_ONE].hash}
                                onDelete={() => props.removePdf(PDF_TYPES.EXTERNAL_ONE)}
                                onClick={()=> window.open(getGenericAttachmentUrl(props.product[PDF_TYPES.EXTERNAL_ONE].hash), "_blank")}
                              />
                              :
                              null
                        }
                    </div>
                </CardContent>
                <CardActions>
                    <Button
                        color="primary"
                        variant="contained"
                        form="form-product"
                        type="submit">{props.isNew?'Create':'Edit'}</Button>
                    {
                        !props.isNew && (
                            <Button
                                onClick={() => props.changeStoreSettings('isDeleteModalOpen', true)}
                                color="secondary"
                                variant="contained"
                            >Delete</Button>
                        )
                    }
                </CardActions>
            </Card>
            <Snackbar
                open={props.productsStore.sendResponse?true:false}
                message={props.productsStore.sendResponse}
                autoHideDuration={6000}
                onClose={() => {props.changeStoreSettings('sendResponse', '')}}
            />
        </div>
    )
};

export default  withStyles(styles)(ProductsFormComponent) ;



// WEBPACK FOOTER //
// ./src/components/Products/ProductsFormComponent.js